// Colors are hardcoded for ConnectionDetail page styling

/**
 * AboutMeSection - Displays "places lived" on connection detail pages.
 *
 * Hometown (currentCity) used to live here but is now its own HOMETOWN section
 * (HometownSection) — see profile-hometown-sharing. This renders the remaining
 * places-lived line, still part of the About-me bundle.
 *
 * Display Logic:
 * - placesLived (other locations): body-size, grey (Organization colour)
 * - thingsILike is NOT displayed (reserved for future "match" feature)
 *
 * @param {Object} userData - User data containing about me fields
 * @param {string} userData.placesLived - Places lived (comma-separated)
 */
export const AboutMeSection = ({ userData }) => {
  // Check if aboutMe is shared and has places-lived data
  const hasAboutMe = userData?.sharedFields?.includes('aboutMe');
  const hasPlacesLived = userData?.placesLived;

  // Note: thingsILike is not displayed - reserved for future "match" feature
  if (!hasAboutMe || !hasPlacesLived) {
    return null;
  }

  // Other locations — CENTRED, body size, grey (frames, 2026-08-20)
  return (
    <div
      style={{
        width: '100%',
        fontSize: '16px',
        fontWeight: '400',
        color: '#999999',
        textAlign: 'center',
      }}
    >
      {userData.placesLived}
    </div>
  );
};

export default AboutMeSection;
